import Button from "../components/button";
import Modal from "../components/modal";
import Headline5 from "../components/headings/Headline5";

function TestModal(props: any) {

    const onClose = () => {
      props.onClose();
    }

    const handleSubmit = () => {
      props.takeTest()
    }

    return(
        <Modal title={" "} onClose={onClose} size="small">
            <Headline5>Are you sure to Continue?</Headline5>
            <p>You will be redirected to HackerEarth Platform to take the test , Please click on confirm button to continue.</p>
            <div className="popupAction">
              <Button onClick={onClose} type="submit" variant="cancel" size="small">Cancel</Button>
              <Button onClick={handleSubmit} type="submit" variant="primary" size="small">confirm</Button>
            </div>
          </Modal>
    )
}

export default TestModal;